<template>
  <load-page
    ><!--@tab-changed="tabChanged"-->
    <!--
    ============================================================================
    Alerts
    ============================================================================
    -->
    <template v-if="value.onlineResult" slot="alerts">
      <common-error-alerts :status-code="value.onlineResult.statusCode" />
    </template>

    <!--
    ============================================================================
    Debug
    ============================================================================
    -->
    <debug-panel slot="debug">{{ value }}</debug-panel>

    <!--
    ============================================================================
    Tabs
    ============================================================================
    -->
    <template slot="tabs">
      <template v-for="(tab, index) in tabs">
        <template v-if="tab.component">
          <b-tab
            v-if="tab.show == undefined || $resolveFn(tab.show)"
            :key="tab.id || index"
            :id="tab.id"
            @click="handleTabSelection(tab)"
          >
            <template slot="title">
              <i class="fa fa-fw" :class="'fa-' + $resolveFn(tab.icon)"></i>
              <span v-if="isSmUp" class="ml-1">
                {{ $resolveFn(tab.title) }}
              </span>
              <b-badge
                variant="danger"
                v-if="$refs.tabs && $refs.tabs[index].errorCounter"
              >
                {{ $refs.tabs[index].errorCounter }}
              </b-badge>
              <b-badge variant="success" v-if="getCounter(tab.id)">
                {{ getCounter(tab.id) }}
              </b-badge>
            </template>
            <component
              :is="tab.component"
              ref="tabs"
              :value="getValue(tab)"
              :errors="errors"
              :disabled="disabled"
              v-bind="$resolveFn(tab.props)"
              v-on="tab.events"
              @input="handleInput(tab, $event)"
            />
          </b-tab>
        </template>
        <component
          v-else
          :key="index"
          :is="tab"
          :value="value"
          :errors="errors"
          :disabled="disabled"
          @input="valueChanged($event)"
        />
      </template>
    </template>

    <!--
    ============================================================================
    Buttons
    ============================================================================
    -->
    <slot name="buttons" slot="buttons">
      <!--
      ==========================================================================
      Buttons > Cancel
      ==========================================================================
      -->
      <b-button variant="cancel" class="float-left" @click.prevent="cancel()">
        <i class="fa fa-fw fa-arrow-left"></i>
        <span class="d-sm-inline d-none">{{ $t("common.cancel") }}</span>
      </b-button>

      <!--
      ==========================================================================
      Buttons > Edit
      ==========================================================================
      -->
      <b-button
        v-if="disabled && value.permissions.edit"
        variant="edit"
        @click.prevent="edit()"
      >
        <i class="fa fa-fw fa-edit"></i>
        <span class="d-sm-inline d-none">{{ $t("common.edit") }}</span>
      </b-button>

      <!--
      ==========================================================================
      Buttons > Save
      ==========================================================================
      -->
      <b-button
        v-if="!disabled && value.permissions.edit"
        variant="save"
        @click.prevent="save()"
      >
        <i class="fa fa-fw fa-save"></i>
        <span class="d-sm-inline d-none">{{ $t("common.save") }}</span>
      </b-button>

      <!--
      ==========================================================================
      Buttons > Debug
      ==========================================================================
      -->
      <b-button variant="dark" v-b-modal.modal-debug v-if="!$env.production">
        <i class="fa fa-fw fa-code"></i>
        <span class="d-sm-inline d-none">{{ $t("common.debug") }}</span>
      </b-button>

      <!--
      ==========================================================================
      Buttons > Remove
      ==========================================================================
      -->
      <b-button
        v-if="value.permissions.delete"
        variant="remove"
        @click.prevent="remove()"
      >
        <i class="fa fa-fw fa-times"></i>
        <span class="d-sm-inline d-none">{{ $t("common.remove") }}</span>
      </b-button>
    </slot>
  </load-page>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import CountersResetterMixin from "@/common/mixins/CountersResetterMixin";

export default {
  mixins: [EditorMixin, CountersResetterMixin],

  data() {
    return {
      tabCounters: {}
    };
  },

  computed: {
    currentTab() {
      const tabs = this.$refs.tabs;
      if (tabs.length < 1) {
        return null;
      }
      const currentTabIndex = tabs[0].$parent.$parent.currentTab;
      return tabs[currentTabIndex].$parent;
    }
  },

  methods: {
    getValue(tab) {
      const props = this.$resolveFn(tab.props);
      return (props && props.value) || this.value;
    },

    handleInput(tab, ...args) {
      const events = this.$resolveFn(tab.events);
      const h = events && events.input;
      if (h) {
        h(...args);
      } else {
        this.valueChanged(...args);
      }
    },

    load() {
      this.$emit("load");
    },

    cancel() {
      this.$emit("cancel");
    },

    edit() {
      this.$emit("edit");
    },

    async remove() {
      try {
        const removed = await this.getService().remove({
          id: this.value.id
        });
        this.$emit("removed", removed);
      } catch (e) {
        this.$emit("remove-error", e);
      }
    },

    async save(fixes = {}) {
      try {
        this.resetAllErrorCounters();
        this.$emit("reset-errors");
        const { data } = await this.getService().save({
          instance: { ...this.value, ...fixes },
          isNew: this.isNew
        });
        const saved = data;
        this.$emit("saved", saved);
      } catch (e) {
        this.$emit("save-error", e);
      }
    },

    getTab(index) {
      const tabs = this.$refs.tabs;
      //const currentTabIndex = tabs[0].$parent.$parent.currentTab;
      return tabs[index].$parent;
    },

    tabChanged(/*index*/) {
      //console.log('Tab changed', index);
    },

    getCounter(id) {
      if (id) {
        return this.tabCounters[id];
      }
    },

    handleTabSelection(tab) {
      if (tab.tabSelected) {
        tab.tabSelected();
      }
    },

    valueChanged(newValue) {
      this.$emit("input", newValue);
    }
  }
};
</script>
